<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { getImageUrl } from '../utils/image'
import { useSettingsStore } from '../stores/settingsStore'

const settingsStore = useSettingsStore()
const loading = ref(true)
const visibleSections = ref({
  has: () => true,
  add: () => {}
})
let observer = null

const s = ref({
  about_hero_title: '', about_hero_subtitle: '', about_hero_desc: '', about_hero_bg: '',
  about_main_img: '', about_quote_title: '', about_quote_text: '',
  about_core_1_title: '', about_core_1_desc: '', about_core_1_img: '',
  about_core_2_title: '', about_core_2_desc: '', about_core_2_img: '',
  about_core_3_title: '', about_core_3_desc: '', about_core_3_img: '',
  about_core_4_title: '', about_core_4_desc: '', about_core_4_img: '',
  about_vision_title: '', about_vision_desc: '', about_vision_img: '',
  about_mission_title: '', about_mission_desc: '',
  about_stat_1_val: '', about_stat_1_label: '',
  about_stat_2_val: '', about_stat_2_label: '',
  about_stat_3_val: '', about_stat_3_label: '',
  about_stat_4_val: '', about_stat_4_label: '',
  about_cta_title: '', about_cta_desc: '',
  about_content_rich: ''
})

const coreValues = ref([])
const stats = ref([])
const activeCoreIndex = ref(0)

const selectedCoreValue = ref(null)
const isModalOpen = ref(false)

const openModal = (val) => {
  selectedCoreValue.value = val
  isModalOpen.value = true
  document.body.style.overflow = 'hidden'
}

const closeModal = () => {
  isModalOpen.value = false
  setTimeout(() => {
    selectedCoreValue.value = null
  }, 300) // wait for animation
  document.body.style.overflow = 'auto'
}

const isRichContentSet = ref(false)
const showRichContent = ref(true)
const displayRichContent = ref('')

const isEmptyHtml = (html) => {
  if (!html) return true
  const clean = html.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, '').trim()
  return clean === ''
}

const defaultRichContent = `
<h2>เส้นทางแห่งคุณภาพและความน่าเชื่อถือ</h2>
<p>นับตั้งแต่ก่อตั้ง จากจุดเริ่มต้นเมื่อกว่าทศวรรษที่แล้ว ด้วยวิสัยทัศน์ที่จะปฏิวัติแนวคิดของโรงเก็บของทั่วไป เราได้ทุ่มเทพัฒนาผลิตภัณฑ์และบริการอย่างต่อเนื่อง จากโรงเก็บของที่เน้นฟังก์ชันการใช้งานพื้นฐาน สู่การเป็นผู้เชี่ยวชาญด้านโรงเก็บของพรีเมียมที่ผสมผสานทั้งความแข็งแรงทนทาน ดีไซน์ที่สวยงามทันสมัย และนวัตกรรมที่ตอบโจทย์การใช้งานที่หลากหลาย</p>
<p>ตลอดระยะเวลาที่ผ่านมา เราภาคภูมิใจในผลงานที่ได้ส่งมอบให้กับลูกค้าทั่วประเทศไทย ไม่ว่าจะเป็นโรงเก็บของสำหรับบ้านพักอาศัย, รีสอร์ท, หรือแม้แต่โครงการเชิงพาณิชย์ขนาดใหญ่ ทุกชิ้นงานของเราคือการสะท้อนถึงความมุ่งมั่นในคุณภาพและความใส่ใจในรายละเอียด</p>
<h2>ทีมงานผู้เชี่ยวชาญ: พลังขับเคลื่อนสู่ความสำเร็จ</h2>
<p>เบื้องหลังความสำเร็จของเราคือทีมงานที่เปี่ยมด้วยความรู้ ความสามารถ และความมุ่งมั่น ตั้งแต่ทีมวิศวกรและนักออกแบบผู้สร้างสรรค์ ไปจนถึงช่างเทคนิคผู้เชี่ยวชาญและทีมบริการลูกค้าที่พร้อมให้คำปรึกษา ทุกคนล้วนทำงานด้วยความหลงใหลในการส่งมอบสิ่งที่ดีที่สุดให้กับลูกค้า</p>
<p>เราเชื่อมั่นว่า ความเข้าใจในความต้องการของลูกค้า คือกุญแจสำคัญ เราจึงใส่ใจรับฟังทุกข้อเสนอแนะ และพร้อมให้คำแนะนำอย่างมืออาชีพ เพื่อให้มั่นใจว่าโรงเก็บของพรีเมียมที่คุณได้รับนั้น ตรงตามความคาดหวังและใช้งานได้อย่างยาวนาน</p>
<p><strong>ขอขอบคุณที่ไว้วางใจให้เราเป็นส่วนหนึ่งในการสร้างสรรค์พื้นที่จัดเก็บที่สมบูรณ์แบบให้กับคุณ</strong></p>
`

const coreIcons = [
  'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
  'M13 10V3L4 14h7v7l9-11h-7z',
  'M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z',
  'M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477-4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253'
]

const buildComputed = () => {
  const defaultTitles = [
    'วัสดุชั้นเลิศและฝีมืออันประณีต',
    'การออกแบบที่ลงตัว',
    'กระบวนการผลิตที่ได้มาตรฐาน',
    'การติดตั้งที่ปลอดภัยและรวดเร็ว'
  ]
  const defaultDescs = [
    'เราเลือกใช้เฉพาะวัสดุคุณภาพสูงสุด ไม่ว่าจะเป็นเหล็กกล้าเคลือบพิเศษกันสนิม ไม้เนื้อแข็งคุณภาพเยี่ยม หรือวัสดุคอมโพสิตที่ทันสมัย ซึ่งล้วนผ่านการทดสอบเพื่อให้มั่นใจในความทนทานต่อทุกสภาพอากาศของประเทศไทย',
    'ทีมออกแบบของเราทำงานอย่างใกล้ชิดกับลูกค้า เพื่อสร้างสรรค์โรงเก็บของที่เข้ากับสไตล์สถาปัตยกรรมของอาคารและภูมิทัศน์โดยรอบได้อย่างกลมกลืน',
    'เราใช้เทคโนโลยีการผลิตที่ทันสมัย ผสานกับฝีมือช่างผู้เชี่ยวชาญ เพื่อให้ได้โครงสร้างที่แข็งแรง การประกอบที่แม่นยำ และงานเก็บรายละเอียดที่ประณีต',
    'ทีมติดตั้งของเรามีความเชี่ยวชาญและประสบการณ์สูง มั่นใจได้ในความรวดเร็ว ปลอดภัย และได้มาตรฐาน'
  ]
  const defaultImages = [
    'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122?auto=format&fit=crop&w=800&q=80',
    'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=800&q=80'
  ]

  coreValues.value = [1, 2, 3, 4]
    .map(i => {
      let imgUrl = s.value[`about_core_${i}_img`]
      if (!imgUrl) imgUrl = defaultImages[i - 1]
      
      return {
        id: i,
        title: s.value[`about_core_${i}_title`] || defaultTitles[i - 1],
        desc: s.value[`about_core_${i}_desc`] || defaultDescs[i - 1],
        img: imgUrl,
        fallbackImg: defaultImages[i - 1],
        icon: coreIcons[i - 1]
      }
    })
    .filter(v => v.title)

  activeCoreIndex.value = 0

  const defaultStatVals = ['20+', '100%', '7 วัน', '100%']
  const defaultStatLabels = [
    'ปีแห่งประสบการณ์',
    'คัดสรรคุณภาพและบริการ',
    'ระยะเวลาเริ่มต้นในการติดตั้ง\nพร้อมเนรมิตพื้นที่ในฝันของ\nคุณให้เป็นจริง',
    'วัสดุคุณภาพสูง นำเข้าจาก\nสหรัฐอเมริกา เพื่อความ\nทนทานและมาตรฐานระดับ\nโลก'
  ]

  stats.value = [1, 2, 3, 4]
    .map(i => ({
      val: s.value[`about_stat_${i}_val`] || defaultStatVals[i-1],
      label: s.value[`about_stat_${i}_label`] || defaultStatLabels[i-1]
    }))

  // Handle rich content display and visibility
  if (isRichContentSet.value) {
    if (isEmptyHtml(s.value.about_content_rich)) {
      showRichContent.value = false
      displayRichContent.value = ''
    } else {
      showRichContent.value = true
      displayRichContent.value = s.value.about_content_rich
    }
  } else {
    showRichContent.value = true
    displayRichContent.value = defaultRichContent
  }
}

const setupObserver = () => {
  observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        visibleSections.value.add(entry.target.dataset.section)
      }
    })
  }, { threshold: 0.1, rootMargin: "0px 0px -100px 0px" })
  
  document.querySelectorAll('[data-section]').forEach(el => observer.observe(el))
}

const loadSettings = async () => {
  try {
    const res = await fetch('/api/settings')
    const data = await res.json()
    if (data.success && data.data) {
      isRichContentSet.value = 'about_content_rich' in data.data
      Object.keys(s.value).forEach(key => {
        if (data.data[key] !== undefined && data.data[key] !== null) {
          s.value[key] = data.data[key]
        }
      })
      buildComputed()
    }
  } catch (e) {
    console.error('Failed to load about settings:', e)
  } finally {
    loading.value = false
    setTimeout(setupObserver, 100)
  }
}

onMounted(() => loadSettings())
onUnmounted(() => { 
  if (observer) observer.disconnect() 
})
</script>

<template>
  <div class="bg-slate-50 dark:bg-[#06090e] min-h-screen text-slate-900 dark:text-slate-100 overflow-x-hidden font-sans selection:bg-emerald-500/30 selection:text-emerald-900 dark:selection:text-emerald-100">

    <!-- Loading State -->
    <div v-if="loading" class="fixed inset-0 z-50 bg-slate-50 dark:bg-[#06090e] flex justify-center items-center">
      <div class="relative w-20 h-20">
        <div class="absolute inset-0 border-2 border-emerald-100 dark:border-emerald-900/30 rounded-full"></div>
        <div class="absolute inset-0 border-2 border-emerald-500 rounded-full border-t-transparent animate-spin"></div>
        <div class="absolute inset-0 flex items-center justify-center">
          <div class="w-2 h-2 bg-emerald-500 rounded-full animate-pulse"></div>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- ═══ FUTURISTIC GLOWING HERO SECTION ═══ -->
      <section class="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden">
        <!-- Radial Gradients Backdrops -->
        <div class="absolute inset-0 pointer-events-none -z-10 overflow-hidden">
          <div class="absolute -top-[20%] left-1/2 -translate-x-1/2 w-[1000px] h-[600px] bg-gradient-to-br from-emerald-500/20 via-teal-500/10 to-transparent blur-[120px] rounded-full"></div>
          <div class="absolute top-1/3 right-[-10%] w-[450px] h-[450px] bg-cyan-400/10 dark:bg-cyan-500/5 blur-[90px] rounded-full animate-pulse-slow"></div>
          <div class="absolute bottom-0 left-[-10%] w-[500px] h-[500px] bg-emerald-400/10 dark:bg-emerald-600/5 blur-[100px] rounded-full"></div>
          <!-- Fine Grid Pattern -->
          <div class="absolute inset-0 bg-[linear-gradient(to_right,#8080800a_1px,transparent_1px),linear-gradient(to_bottom,#8080800a_1px,transparent_1px)] bg-[size:14px_24px] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]"></div>
        </div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div class="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
            
            <!-- Text Content -->
            <div class="lg:col-span-5 text-left z-10" style="animation-delay: 100ms;">
              <div v-if="s.about_hero_subtitle" class="inline-flex items-center gap-2.5 px-4.5 py-1.5 rounded-full bg-emerald-50/80 dark:bg-emerald-950/30 backdrop-blur-md border border-emerald-100/50 dark:border-emerald-900/30 shadow-sm mb-6">
                <span class="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse"></span>
                <span class="text-xs font-bold tracking-widest uppercase text-emerald-800 dark:text-emerald-300">{{ s.about_hero_subtitle }}</span>
              </div>
              
              <h1 class="text-4xl sm:text-5xl lg:text-6xl font-black text-slate-900 dark:text-white tracking-tight leading-[1.15] mb-6">
                <span class="block text-slate-800 dark:text-slate-200 font-extrabold text-3xl sm:text-4xl lg:text-5xl mb-2">ยินดีต้อนรับสู่ Greenhouse</span>
                <span class="bg-gradient-to-r from-emerald-600 via-teal-500 to-cyan-500 dark:from-emerald-400 dark:via-teal-400 dark:to-cyan-400 bg-clip-text text-transparent">
                  โรงเก็บของพรีเมียม
                </span>
              </h1>
              
              <p class="text-base sm:text-lg text-slate-600 dark:text-slate-400 leading-relaxed mb-8 whitespace-pre-line font-light">
                {{ s.about_hero_desc || 'เราคือผู้นำในการรังสรรค์และติดตั้งโรงเก็บของพรีเมียมคุณภาพสูง ที่ไม่เพียงแต่ตอบสนองความต้องการด้านการจัดเก็บ แต่ยังยกระดับความสวยงามและเพิ่มมูลค่าให้กับพื้นที่ของคุณ' }}
              </p>

              <div class="flex flex-wrap items-center gap-4">
                <router-link to="/contact" class="group relative px-7 py-3.5 bg-emerald-600 hover:bg-emerald-500 text-white font-bold rounded-xl overflow-hidden shadow-lg shadow-emerald-600/20 transition-all duration-300 hover:-translate-y-0.5">
                  <div class="absolute inset-0 w-full h-full bg-gradient-to-r from-transparent via-white/10 to-transparent -translate-x-full group-hover:animate-shimmer"></div>
                  <span class="relative flex items-center gap-2 text-sm md:text-base">
                    ติดต่อเรา
                    <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M14 5l7 7m0 0l-7 7m7-7H3"/></svg>
                  </span>
                </router-link>
                <router-link to="/services" class="px-7 py-3.5 bg-white dark:bg-[#111827] hover:bg-slate-50 dark:hover:bg-[#1a2332] text-slate-700 dark:text-slate-200 font-bold rounded-xl border border-slate-200 dark:border-slate-800/80 transition-all duration-300 hover:-translate-y-0.5 shadow-sm text-sm md:text-base">
                  ดูบริการทั้งหมด
                </router-link>
              </div>
            </div>

            <!-- Redesigned Image Showcase with Rotating Circular Badge -->
            <div class="lg:col-span-7 relative z-10" style="animation-delay: 300ms;">
              <div class="relative w-full aspect-[4/3] sm:aspect-[16/10] rounded-[2rem] overflow-hidden shadow-2xl border-4 border-white dark:border-[#111827] bg-slate-100 dark:bg-slate-800">
                <img v-if="s.about_hero_bg || s.about_main_img" 
                     :src="getImageUrl(s.about_hero_bg || s.about_main_img)" 
                     alt="Hero" 
                     class="w-full h-full object-cover transform hover:scale-105 transition-transform duration-[1200ms]"
                     @error="$event.target.src = 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80'" />
                <img v-else src="https://images.unsplash.com/photo-1512917774080-9991f1c4c750?auto=format&fit=crop&w=1900&q=80" alt="Modern Architecture" class="w-full h-full object-cover transform hover:scale-105 transition-transform duration-[1200ms]" />
                
                <div class="absolute inset-0 bg-gradient-to-t from-slate-950/20 to-transparent"></div>
              </div>

              <!-- Rotating circular badge -->
              <div class="absolute -bottom-8 -right-4 sm:-bottom-10 sm:right-6 w-28 h-28 sm:w-32 sm:h-32 bg-white dark:bg-[#111827] p-2.5 rounded-full shadow-[0_15px_35px_rgba(0,0,0,0.12)] border border-slate-100 dark:border-slate-800 flex items-center justify-center animate-spin-slow hover:pause cursor-default">
                <div class="relative w-full h-full rounded-full bg-slate-50 dark:bg-[#1a2332] flex items-center justify-center">
                  <!-- SVG Circle Text -->
                  <svg class="absolute w-full h-full" viewBox="0 0 100 100">
                    <path id="circlePath" d="M 50,50 m -37,0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" fill="none" />
                    <text class="text-[8px] font-bold fill-slate-700 dark:fill-slate-300 tracking-[3.8px]">
                      <textPath href="#circlePath">GREENHOUSE • PREMIUM SHED • QUALITY •</textPath>
                    </text>
                  </svg>
                  <svg class="w-7 h-7 text-emerald-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                  </svg>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <!-- ═══ BENTO GRID: STATS & STORY ═══ -->
      <section class="py-16 relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          
          <!-- Bento Card 1: Our Story / Heritage (Spans 2 columns) -->
          <div :data-section="'bento-story'"
               class="md:col-span-2 bg-white dark:bg-[#111827] rounded-[2.5rem] p-8 md:p-10 border border-slate-100 dark:border-slate-800/80 shadow-[0_8px_30px_rgba(0,0,0,0.02)] relative overflow-hidden group flex flex-col justify-between min-h-[340px] transition-all duration-700 transform"
               :class="visibleSections.has('bento-story') ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'">
            <!-- Glowing gradient ball -->
            <div class="absolute -right-10 -bottom-10 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl group-hover:scale-125 transition-transform duration-700"></div>
            
            <div>
              <span class="text-emerald-500 font-bold uppercase tracking-wider text-xs md:text-sm">Greenhouse Story</span>
              <h2 class="text-2xl md:text-3xl font-black text-slate-800 dark:text-slate-100 mt-2 mb-4 leading-tight">
                นวัตกรรมการจัดเก็บสไตล์โมเดิร์น
              </h2>
              <p class="text-slate-500 dark:text-slate-400 text-sm md:text-base leading-relaxed max-w-2xl font-light">
                เริ่มต้นจากการทลายกรอบเดิมของโรงเก็บของทั่วไป สู่การเป็นผู้เชี่ยวชาญการผลิตโรงเก็บของสำเร็จรูประดับพรีเมียมที่ผสานศาสตร์การออกแบบสมัยใหม่ เข้ากับโครงสร้างวิศวกรรมที่ทนทานต่อสภาพภูมิอากาศเขตร้อนของเมืองไทยได้อย่างสมบูรณ์แบบ
              </p>
            </div>

            <!-- Features Grid Inside Bento -->
            <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 pt-6 mt-6 border-t border-slate-100 dark:border-slate-800">
              <div class="flex items-center gap-2">
                <div class="w-6.5 h-6.5 rounded-lg bg-emerald-50 dark:bg-emerald-950/50 flex items-center justify-center text-emerald-500 shrink-0">✓</div>
                <span class="text-xs sm:text-sm font-semibold text-slate-700 dark:text-slate-300">ความปลอดภัยสูงสุด</span>
              </div>
              <div class="flex items-center gap-2">
                <div class="w-6.5 h-6.5 rounded-lg bg-teal-50 dark:bg-teal-950/50 flex items-center justify-center text-teal-500 shrink-0">✓</div>
                <span class="text-xs sm:text-sm font-semibold text-slate-700 dark:text-slate-300">โครงสร้างวิศวกรรม</span>
              </div>
              <div class="flex items-center gap-2 col-span-2 sm:col-span-1">
                <div class="w-6.5 h-6.5 rounded-lg bg-cyan-50 dark:bg-cyan-950/50 flex items-center justify-center text-cyan-500 shrink-0">✓</div>
                <span class="text-xs sm:text-sm font-semibold text-slate-700 dark:text-slate-300">ทีมติดตั้งมืออาชีพ</span>
              </div>
            </div>
          </div>

          <!-- Bento Card 2: Stat 1 - Experience (Spans 1 column) -->
          <div v-if="stats[0]"
               :data-section="'bento-stat-0'"
               class="bg-white dark:bg-[#111827] rounded-[2.5rem] p-8 md:p-10 border border-slate-100 dark:border-slate-800/80 shadow-[0_8px_30px_rgba(0,0,0,0.02)] flex flex-col justify-between relative overflow-hidden transition-all duration-700 transform"
               :class="visibleSections.has('bento-stat-0') ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'"
               style="transition-delay: 100ms;">
            <!-- Circular graph background -->
            <div class="absolute -right-8 -top-8 w-32 h-32 border-[10px] border-emerald-500/5 rounded-full pointer-events-none"></div>
            
            <div class="flex justify-between items-start">
              <span class="p-2.5 rounded-2xl bg-emerald-50 dark:bg-emerald-950/30 text-emerald-500">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
              </span>
              <span class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">Experience</span>
            </div>

            <div class="mt-8">
              <div class="text-5xl md:text-6xl font-black text-emerald-600 dark:text-emerald-400 tracking-tighter leading-none mb-3">
                {{ stats[0].val }}
              </div>
              <p class="text-slate-600 dark:text-slate-400 text-sm md:text-base font-medium leading-normal whitespace-pre-line">{{ stats[0].label }}</p>
            </div>
          </div>

          <!-- Bento Card 3: Stat 2 - Customer Quality (Spans 1 column) -->
          <div v-if="stats[1]"
               :data-section="'bento-stat-1'"
               class="bg-white dark:bg-[#111827] rounded-[2.5rem] p-8 md:p-10 border border-slate-100 dark:border-slate-800/80 shadow-[0_8px_30px_rgba(0,0,0,0.02)] flex flex-col justify-between relative overflow-hidden transition-all duration-700 transform"
               :class="visibleSections.has('bento-stat-1') ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'"
               style="transition-delay: 200ms;">
            <div class="flex justify-between items-start">
              <span class="p-2.5 rounded-2xl bg-teal-50 dark:bg-teal-950/30 text-teal-500">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"/></svg>
              </span>
              <span class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">Service Quality</span>
            </div>

            <div class="mt-8">
              <div class="text-5xl md:text-6xl font-black text-teal-600 dark:text-teal-400 tracking-tighter leading-none mb-3">
                {{ stats[1].val }}
              </div>
              <p class="text-slate-600 dark:text-slate-400 text-[13px] md:text-sm leading-normal whitespace-pre-line">{{ stats[1].label }}</p>
            </div>
          </div>

          <!-- Bento Card 4: Stat 3 - Fast Installation (Spans 1 column) -->
          <div v-if="stats[2]"
               :data-section="'bento-stat-2'"
               class="bg-white dark:bg-[#111827] rounded-[2.5rem] p-8 md:p-10 border border-slate-100 dark:border-slate-800/80 shadow-[0_8px_30px_rgba(0,0,0,0.02)] flex flex-col justify-between relative overflow-hidden transition-all duration-700 transform"
               :class="visibleSections.has('bento-stat-2') ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'"
               style="transition-delay: 300ms;">
            <div class="flex justify-between items-start">
              <span class="p-2.5 rounded-2xl bg-cyan-50 dark:bg-cyan-950/30 text-cyan-500">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"/></svg>
              </span>
              <span class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">Efficiency</span>
            </div>

            <div class="mt-8">
              <div class="text-5xl md:text-6xl font-black text-cyan-600 dark:text-cyan-400 tracking-tighter leading-none mb-3">
                {{ stats[2].val }}
              </div>
              <p class="text-slate-600 dark:text-slate-400 text-[13px] md:text-sm leading-normal whitespace-pre-line">{{ stats[2].label }}</p>
            </div>
          </div>

          <!-- Bento Card 5: Stat 4 - Premium Materials (Spans 1 column) -->
          <div v-if="stats[3]"
               :data-section="'bento-stat-3'"
               class="bg-white dark:bg-[#111827] rounded-[2.5rem] p-8 md:p-10 border border-slate-100 dark:border-slate-800/80 shadow-[0_8px_30px_rgba(0,0,0,0.02)] flex flex-col justify-between relative overflow-hidden transition-all duration-700 transform"
               :class="visibleSections.has('bento-stat-3') ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'"
               style="transition-delay: 400ms;">
            <div class="flex justify-between items-start">
              <span class="p-2.5 rounded-2xl bg-emerald-50 dark:bg-emerald-950/30 text-emerald-500">
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 002 2h1.5A2.5 2.5 0 0019 9.5V8a.5.5 0 01.5-.5h.5M3 12a9 9 0 1118 0 9 9 0 01-18 0z"/></svg>
              </span>
              <span class="text-xs font-bold text-slate-400 dark:text-slate-500 uppercase tracking-widest">Standards</span>
            </div>

            <div class="mt-8">
              <div class="text-5xl md:text-6xl font-black text-emerald-600 dark:text-emerald-400 tracking-tighter leading-none mb-3">
                {{ stats[3].val }}
              </div>
              <p class="text-slate-600 dark:text-slate-400 text-[13px] md:text-sm leading-normal whitespace-pre-line">{{ stats[3].label }}</p>
            </div>
          </div>

        </div>
      </section>

      <!-- ═══ CORE VALUES (Redesigned Split Interactive Tabs) ═══ -->
      <section v-if="coreValues.length" class="py-24 bg-white dark:bg-[#0a0f16] relative overflow-hidden">
        <!-- Glowing Ambient Dots -->
        <div class="absolute top-[20%] left-[-5%] w-72 h-72 bg-emerald-500/5 dark:bg-emerald-500/5 blur-[120px] rounded-full pointer-events-none"></div>
        <div class="absolute bottom-[20%] right-[-5%] w-72 h-72 bg-teal-500/5 dark:bg-teal-500/5 blur-[120px] rounded-full pointer-events-none"></div>

        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          
          <!-- Header -->
          <div data-section="core-header" class="text-center mb-16 transition-all duration-700 transform" :class="visibleSections.has('core-header') ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'">
            <span class="text-emerald-600 dark:text-emerald-400 font-bold tracking-widest uppercase text-xs sm:text-sm mb-3 block">Why Choose Us</span>
            <h2 class="text-3xl md:text-5xl font-black text-slate-900 dark:text-white mb-6">หัวใจสำคัญ: วัสดุและบริการชั้นเลิศ</h2>
            <div class="w-16 h-1 bg-gradient-to-r from-emerald-500 to-teal-400 rounded-full mx-auto"></div>
          </div>

          <!-- Mobile View: Quick Cards + Modal Triggers (below md) -->
          <div class="md:hidden grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div v-for="(val, index) in coreValues" :key="'mob-'+index" 
                 :data-section="'core-mob-'+index"
                 @click="openModal(val)"
                 class="group relative h-[360px] rounded-3xl overflow-hidden cursor-pointer shadow-md border border-slate-100 dark:border-slate-800 transition-all duration-500"
                 :class="visibleSections.has('core-mob-'+index) ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'">
              
              <!-- Background Image -->
              <img v-if="val.img" :src="getImageUrl(val.img)" :alt="val.title" 
                   class="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" 
                   @error="$event.target.src = val.fallbackImg" />
              <div v-else class="absolute inset-0 w-full h-full bg-slate-100 dark:bg-slate-800"></div>
              
              <div class="absolute inset-0 bg-gradient-to-t from-slate-950/95 via-slate-950/60 to-transparent"></div>
              
              <!-- Content -->
              <div class="absolute inset-0 p-6 flex flex-col justify-end">
                <div class="w-11 h-11 rounded-xl bg-white/20 backdrop-blur-md border border-white/20 flex items-center justify-center mb-4 text-white">
                  <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" :d="val.icon"></path></svg>
                </div>
                <h3 class="text-lg font-black text-white mb-1.5">{{ val.title }}</h3>
                <p class="text-slate-300 text-xs line-clamp-2">{{ val.desc }}</p>
              </div>
            </div>
          </div>

          <!-- Desktop View: Interactive Split Tabs System (md and up) -->
          <div class="hidden md:grid grid-cols-12 gap-8 items-stretch lg:gap-12 min-h-[480px]">
            
            <!-- Left Tabs (4 cols) -->
            <div class="col-span-5 flex flex-col justify-center space-y-4">
              <button v-for="(val, index) in coreValues" :key="'tab-'+index"
                      @click="activeCoreIndex = index"
                      class="w-full text-left p-6 rounded-2xl border transition-all duration-300 flex items-center gap-5 focus:outline-none relative group"
                      :class="activeCoreIndex === index 
                        ? 'bg-emerald-500/[0.04] dark:bg-emerald-500/[0.02] border-emerald-500/30 dark:border-emerald-500/20 shadow-[0_4px_20px_rgba(16,185,129,0.04)]' 
                        : 'bg-transparent border-transparent hover:bg-slate-50 dark:hover:bg-slate-800/40 opacity-70 hover:opacity-100'">
                
                <!-- Vertical Indicator Line -->
                <div class="absolute left-0 top-1/2 -translate-y-1/2 w-1 rounded-full bg-emerald-500 transition-all duration-300"
                     :class="activeCoreIndex === index ? 'h-1/2' : 'h-0 group-hover:h-1/4'"></div>

                <div class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 transition-colors duration-300"
                     :class="activeCoreIndex === index 
                       ? 'bg-emerald-500 text-white shadow-md shadow-emerald-500/20' 
                       : 'bg-slate-100 dark:bg-slate-800 text-slate-500 dark:text-slate-400 group-hover:bg-emerald-100 group-hover:text-emerald-600 dark:group-hover:bg-emerald-950/30'">
                  <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="val.icon"></path></svg>
                </div>
                <div>
                  <h3 class="font-black text-base lg:text-lg transition-colors"
                      :class="activeCoreIndex === index ? 'text-emerald-700 dark:text-emerald-400' : 'text-slate-700 dark:text-slate-300'">
                    {{ val.title }}
                  </h3>
                  <p class="text-xs lg:text-sm text-slate-400 dark:text-slate-500 mt-1 line-clamp-1 font-light">{{ val.desc }}</p>
                </div>
              </button>
            </div>

            <!-- Right Showcase Panel (7 cols) -->
            <div class="col-span-7 relative">
              <div>
                <div :key="activeCoreIndex" class="h-full bg-slate-50 dark:bg-[#111827] border border-slate-100 dark:border-slate-800 rounded-[2.5rem] overflow-hidden flex flex-col justify-between shadow-[0_15px_35px_rgba(0,0,0,0.03)] dark:shadow-none">
                  
                  <!-- Showcase Image with Overlay -->
                  <div class="h-60 lg:h-72 relative overflow-hidden bg-slate-200 dark:bg-slate-800 shrink-0">
                    <img v-if="coreValues[activeCoreIndex].img" 
                         :src="getImageUrl(coreValues[activeCoreIndex].img)" 
                         :alt="coreValues[activeCoreIndex].title" 
                         class="w-full h-full object-cover transform scale-100 hover:scale-105 transition-transform duration-[1.5s]" 
                         @error="$event.target.src = coreValues[activeCoreIndex].fallbackImg" />
                    
                    <div class="absolute inset-0 bg-gradient-to-t from-slate-50 dark:from-[#111827] via-transparent to-transparent"></div>
                  </div>

                  <!-- Details -->
                  <div class="p-8 lg:p-10 flex-grow flex flex-col justify-between">
                    <div>
                      <div class="flex items-center gap-3 mb-4">
                        <span class="text-xs font-black text-emerald-600 dark:text-emerald-400 tracking-widest uppercase">Feature {{ coreValues[activeCoreIndex].id }}</span>
                        <div class="w-6 h-px bg-slate-200 dark:bg-slate-700"></div>
                      </div>
                      <h3 class="text-2xl font-black text-slate-800 dark:text-slate-100 mb-4 leading-snug">
                        {{ coreValues[activeCoreIndex].title }}
                      </h3>
                      <p class="text-slate-500 dark:text-slate-400 text-sm lg:text-base leading-relaxed font-light whitespace-pre-line">
                        {{ coreValues[activeCoreIndex].desc }}
                      </p>
                    </div>

                    <!-- Visual bullet points -->
                    <div class="grid grid-cols-2 gap-4 mt-6 pt-6 border-t border-slate-200/60 dark:border-slate-800/80">
                      <div class="flex items-center gap-2.5">
                        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                        <span class="text-xs text-slate-500 dark:text-slate-400">ควบคุมคุณภาพทุกขั้นตอน</span>
                      </div>
                      <div class="flex items-center gap-2.5">
                        <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                        <span class="text-xs text-slate-500 dark:text-slate-400">รับประกันวัสดุแท้ 100%</span>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      <!-- ═══ MAIN VISUAL & QUOTE SECTION (Parallax Styled) ═══ -->
      <section data-section="quote" class="py-24 bg-slate-50 dark:bg-[#06090e] transition-all duration-700 transform" :class="visibleSections.has('quote') ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'">
        
        <!-- Main Visual Image -->
        <div v-if="s.about_main_img" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
          <div class="w-full aspect-video sm:aspect-[21/9] rounded-[2.5rem] overflow-hidden shadow-[0_20px_50px_rgba(0,0,0,0.06)] border-[6px] border-white dark:border-[#111827]">
            <img :src="getImageUrl(s.about_main_img)" class="w-full h-full object-cover transform hover:scale-105 transition-transform duration-[1.2s]" alt="Main Visual" />
          </div>
        </div>

        <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <!-- Giant Background Quote Icon -->
          <svg class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 md:w-64 md:h-64 text-emerald-500/[0.03] dark:text-emerald-500/[0.02] rotate-180 pointer-events-none" fill="currentColor" viewBox="0 0 24 24"><path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/></svg>
          
          <div class="relative z-10 bg-white/40 dark:bg-white/[0.01] backdrop-blur-sm p-8 md:p-12 rounded-[2rem] border border-white/50 dark:border-white/5 shadow-sm">
            <h2 class="text-sm font-bold text-emerald-600 dark:text-emerald-400 mb-6 uppercase tracking-widest">{{ s.about_quote_title || 'แรงบันดาลใจที่ส่งต่อสู่พันธกิจ' }}</h2>
            <p class="text-xl md:text-3xl lg:text-4xl font-extrabold text-slate-800 dark:text-slate-100 leading-relaxed italic font-serif">
              "{{ s.about_quote_text || 'ด้วยความเข้าใจอย่างลึกซึ้งในความต้องการของลูกค้าและประสบการณ์อันยาวนาน เรามุ่งมั่นที่จะนำเสนอโซลูชั่นที่เหนือกว่าในทุกด้าน' }}"
            </p>
          </div>
        </div>
      </section>

      <!-- ═══ VISION & MISSION (Redesigned Split Curved Cards) ═══ -->
      <section data-section="vision" class="py-24 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-[1000ms] transform" :class="visibleSections.has('vision') ? 'translate-y-0 opacity-100' : 'translate-y-16 opacity-0'">
        <div class="grid grid-cols-1 lg:grid-cols-12 gap-8 items-stretch">
          
          <!-- Image Card (lg:col-span-5) -->
          <div class="lg:col-span-5 rounded-[2.5rem] overflow-hidden relative min-h-[300px] lg:min-h-full border border-slate-100 dark:border-slate-800/60 shadow-lg">
            <img v-if="s.about_vision_img" 
                 :src="getImageUrl(s.about_vision_img)" 
                 class="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition-transform duration-[1.5s]" 
                 @error="$event.target.src = 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80'" />
            <img v-else src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1200&q=80" class="absolute inset-0 w-full h-full object-cover" />
            <!-- Beautiful gradient vignette overlay -->
            <div class="absolute inset-0 bg-gradient-to-t from-slate-950/60 via-slate-950/20 to-transparent"></div>
            
            <div class="absolute bottom-6 left-6 right-6 text-white">
              <span class="text-xs font-bold tracking-widest uppercase text-emerald-400">Greenhouse Standards</span>
              <p class="text-lg font-black mt-1">ยกระดับพื้นที่จัดเก็บทุกตารางนิ้ว</p>
            </div>
          </div>

          <!-- Content Card (lg:col-span-7) -->
          <div class="lg:col-span-7 bg-white dark:bg-[#111827] border border-slate-100 dark:border-slate-800/80 rounded-[2.5rem] p-8 md:p-12 shadow-[0_15px_40px_rgba(0,0,0,0.03)] flex flex-col justify-center">
            <div class="space-y-12">
              
              <!-- Vision -->
              <div v-if="s.about_vision_title || s.about_vision_desc" class="flex gap-6 items-start group">
                <div class="w-12 h-12 rounded-xl bg-emerald-50 dark:bg-emerald-950/30 text-emerald-600 dark:text-emerald-400 flex items-center justify-center shrink-0 border border-emerald-100/30 dark:border-emerald-800/30 transition-transform duration-300 group-hover:scale-110 shadow-sm">
                  <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path></svg>
                </div>
                <div>
                  <h3 class="text-xl md:text-2xl font-black text-slate-900 dark:text-white mb-2.5 transition-colors group-hover:text-emerald-600 dark:group-hover:text-emerald-400">{{ s.about_vision_title || 'วิสัยทัศน์ของเรา' }}</h3>
                  <p class="text-sm md:text-base text-slate-500 dark:text-slate-400 leading-relaxed font-light whitespace-pre-line">{{ s.about_vision_desc }}</p>
                </div>
              </div>

              <!-- Line divider separator -->
              <div class="h-px bg-slate-100 dark:bg-slate-800 ml-18"></div>

              <!-- Mission -->
              <div v-if="s.about_mission_title || s.about_mission_desc" class="flex gap-6 items-start group">
                <div class="w-12 h-12 rounded-xl bg-teal-50 dark:bg-teal-950/30 text-teal-600 dark:text-teal-400 flex items-center justify-center shrink-0 border border-teal-100/30 dark:border-teal-800/30 transition-transform duration-300 group-hover:scale-110 shadow-sm">
                  <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.2" d="M13 10V3L4 14h7v7l9-11h-7z"></path></svg>
                </div>
                <div>
                  <h3 class="text-xl md:text-2xl font-black text-slate-900 dark:text-white mb-2.5 transition-colors group-hover:text-teal-600 dark:group-hover:text-teal-400">{{ s.about_mission_title || 'พันธกิจของเรา' }}</h3>
                  <p class="text-sm md:text-base text-slate-500 dark:text-slate-400 leading-relaxed font-light whitespace-pre-line">{{ s.about_mission_desc }}</p>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <!-- ═══ RICH CONTENT (Refined Editorial Style) ═══ -->
      <section v-if="showRichContent" class="py-24 bg-white dark:bg-[#0a0f16]">
        <div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-section="rich" class="transition-all duration-1000 transform" :class="visibleSections.has('rich') ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'">
            <div class="about-rich-content prose prose-lg prose-emerald dark:prose-invert max-w-none text-slate-700 dark:text-slate-300 font-light" v-html="displayRichContent"></div>
          </div>
        </div>
      </section>

      <!-- ═══ CTA SECTION (Sleek Horizontal Banner) ═══ -->
      <section data-section="cta" class="pb-24 px-4 transition-all duration-700 transform" :class="visibleSections.has('cta') ? 'translate-y-0 opacity-100' : 'translate-y-12 opacity-0'">
        <div class="max-w-5xl mx-auto relative group">
          <!-- Animated Background Gradient Layer -->
          <div class="absolute inset-0 bg-gradient-to-r from-emerald-500/10 via-teal-500/5 to-cyan-500/10 rounded-[2rem] blur-xl opacity-75 -z-10"></div>
          
          <div class="relative bg-slate-900 dark:bg-[#0b0f19] rounded-[2rem] p-8 md:p-12 border border-slate-800 dark:border-emerald-500/10 shadow-2xl overflow-hidden">
            <!-- Decorative light effects -->
            <div class="absolute -right-16 -top-16 w-48 h-48 bg-emerald-500/10 rounded-full blur-3xl pointer-events-none"></div>
            <div class="absolute -left-16 -bottom-16 w-48 h-48 bg-teal-500/10 rounded-full blur-3xl pointer-events-none"></div>

            <div class="flex flex-col lg:flex-row items-center justify-between gap-8 relative z-10">
              <!-- Text: Left Side -->
              <div class="text-center lg:text-left max-w-2xl">
                <h2 class="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-3 tracking-tight leading-tight">
                  {{ s.about_cta_title || 'พร้อมที่จะเริ่มต้นโครงการของคุณหรือยัง?' }}
                </h2>
                <p class="text-sm md:text-base text-slate-400 max-w-xl leading-relaxed font-light">
                  {{ s.about_cta_desc || 'ติดต่อเราวันนี้เพื่อรับคำปรึกษาและใบเสนอราคาฟรี ทีมงานผู้เชี่ยวชาญของเราพร้อมที่จะเนรมิตพื้นที่ในฝันของคุณให้เป็นจริง' }}
                </p>
              </div>

              <!-- Buttons: Right Side -->
              <div class="flex flex-col sm:flex-row gap-4 w-full lg:w-auto shrink-0 justify-center items-center">
                <router-link to="/quotation" 
                             class="w-full sm:w-auto inline-flex items-center justify-center px-7 py-3.5 bg-white hover:bg-slate-100 text-slate-900 font-bold rounded-xl shadow-lg transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap text-sm md:text-base">
                  ประเมินราคาฟรี
                </router-link>
                <a v-if="settingsStore.contactLines.length > 0"
                   :href="settingsStore.contactLines[0].url || ('https://line.me/ti/p/~' + (settingsStore.contactLines[0].value || '').replace(/^@/, ''))"
                   target="_blank"
                   class="w-full sm:w-auto inline-flex items-center justify-center px-7 py-3.5 bg-[#06C755] hover:bg-[#05B34B] text-white font-bold rounded-xl shadow-lg transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap text-sm md:text-base gap-2">
                  <svg class="w-5 h-5 shrink-0" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M24 10.304c0-5.369-5.383-9.738-12-9.738-6.616 0-12 4.369-12 9.738 0 4.814 3.966 8.887 9.539 9.613.385.082.906.262 1.042.6.12.3.05.748.024 1.036l-.16 1.94c-.039.232-.178 1.066.938.595 1.114-.47 6.012-3.542 8.441-6.234 2.802-3.09 4.176-5.834 4.176-7.55z"/>
                  </svg>
                  ติดต่อผ่าน LINE
                </a>
              </div>
            </div>

          </div>
        </div>
      </section>

      <!-- Core Value Modal (Mobile Fallback) -->
      <transition 
        enter-active-class="transition duration-300 ease-out" 
        enter-from-class="opacity-0" 
        enter-to-class="opacity-100" 
        leave-active-class="transition duration-200 ease-in" 
        leave-from-class="opacity-100" 
        leave-to-class="opacity-0">
        <div v-if="isModalOpen && selectedCoreValue" class="fixed inset-0 z-[100] flex items-center justify-center p-4">
          <div class="absolute inset-0 bg-slate-900/60 backdrop-blur-sm cursor-pointer" @click="closeModal"></div>
          
          <div class="relative bg-white dark:bg-[#111827] rounded-[2rem] shadow-2xl w-full max-w-lg overflow-hidden" @click.stop>
            <button @click="closeModal" class="absolute top-4 right-4 w-9 h-9 bg-black/20 hover:bg-black/40 backdrop-blur-md rounded-full flex items-center justify-center text-white z-20 transition-colors">
              <svg class="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
            </button>
            
            <div class="h-48 relative">
              <img v-if="selectedCoreValue.img" :src="getImageUrl(selectedCoreValue.img)" :alt="selectedCoreValue.title" class="w-full h-full object-cover" @error="$event.target.src = selectedCoreValue.fallbackImg" />
              <div v-else class="w-full h-full bg-slate-200 dark:bg-slate-800"></div>
              
              <div class="absolute inset-0 bg-gradient-to-t from-slate-900 via-slate-900/50 to-transparent"></div>
              
              <div class="absolute bottom-5 left-5 right-5 flex items-center gap-3.5 z-10">
                 <div class="w-11 h-11 rounded-xl bg-white/20 backdrop-blur-md border border-white/30 flex items-center justify-center text-white shrink-0 shadow-lg">
                    <svg class="w-5.5 h-5.5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" :d="selectedCoreValue.icon"></path></svg>
                  </div>
                  <h3 class="text-xl font-black text-white drop-shadow-md">{{ selectedCoreValue.title }}</h3>
              </div>
            </div>
            
            <div class="p-6 max-h-[50vh] overflow-y-auto custom-scrollbar bg-white dark:bg-[#0f172a]">
              <p class="text-slate-600 dark:text-slate-300 leading-relaxed text-sm md:text-base whitespace-pre-line font-light">
                {{ selectedCoreValue.desc }}
              </p>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}
.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}
.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.dark .custom-scrollbar::-webkit-scrollbar-thumb {
  background: #334155;
}
.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.animate-spin-slow {
  animation: spin 16s linear infinite;
}

.animate-pulse-slow {
  animation: pulse 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>

<style scoped>
@keyframes shimmer {

  100% { transform: translateX(100%); }
}

.animate-shimmer {
  animation: shimmer 2.2s infinite;
}

/* ── Rich Content Styles ── */
.about-rich-content :deep(h2), .about-rich-content :deep(h3), .about-rich-content :deep(h4) { color: #0f172a; font-weight: 950; margin-top: 3.5rem; margin-bottom: 1.5rem; line-height: 1.2; letter-spacing: -0.02em; }
:global(.dark) .about-rich-content :deep(h2), :global(.dark) .about-rich-content :deep(h3), :global(.dark) .about-rich-content :deep(h4) { color: #f8fafc; }
.about-rich-content :deep(h2) { font-size: 2.25rem; }
.about-rich-content :deep(h3) { font-size: 1.75rem; }
.about-rich-content :deep(p) { color: #475569; line-height: 1.8; margin-bottom: 2rem; font-size: 1.075rem; font-weight: 300; }
:global(.dark) .about-rich-content :deep(p) { color: #cbd5e1; }
.about-rich-content :deep(strong) { color: #0f172a; font-weight: 700; }
:global(.dark) .about-rich-content :deep(strong) { color: #f8fafc; }
.about-rich-content :deep(ul), .about-rich-content :deep(ol) { padding-left: 1.5rem; margin-bottom: 2rem; }
.about-rich-content :deep(li) { margin-bottom: 0.75rem; line-height: 1.8; color: #475569; font-weight: 300; font-size: 1.075rem; }
:global(.dark) .about-rich-content :deep(li) { color: #cbd5e1; }
.about-rich-content :deep(li::marker) { color: #10b981; }
.about-rich-content :deep(a) { color: #059669; text-decoration: none; border-bottom: 1px solid #059669; padding-bottom: 2px; transition: all 0.2s; font-weight: 500;}
:global(.dark) .about-rich-content :deep(a) { color: #34d399; border-bottom-color: #34d399; }
.about-rich-content :deep(a:hover) { color: #047857; border-bottom-color: #047857; }
:global(.dark) .about-rich-content :deep(a:hover) { color: #10b981; border-bottom-color: #10b981; }
.about-rich-content :deep(table) { width: 100% !important; border-collapse: separate !important; border-spacing: 0 !important; border-radius: 1.5rem; overflow: hidden; margin: 3rem auto; border: 1px solid #e2e8f0 !important; background-color: #fff; box-shadow: 0 10px 15px -3px rgba(0,0,0,0.05); }
:global(.dark) .about-rich-content :deep(table) { border-color: #1e293b !important; background-color: #0f172a; box-shadow: none; }
.about-rich-content :deep(table thead) { background-color: #f8fafc; }
:global(.dark) .about-rich-content :deep(table thead) { background-color: #1e293b; }
.about-rich-content :deep(table thead th) { color: #0f172a; font-weight: 700; padding: 1.25rem 1.5rem; text-align: left; border-bottom: 1px solid #e2e8f0; font-size: 0.875rem; text-transform: uppercase; letter-spacing: 0.05em; }
:global(.dark) .about-rich-content :deep(table thead th) { color: #f8fafc; border-bottom-color: #334155; }
.about-rich-content :deep(table tbody tr:nth-child(even)) { background-color: #f8fafc; }
:global(.dark) .about-rich-content :deep(table tbody tr:nth-child(even)) { background-color: #0f172a; }
.about-rich-content :deep(table tbody tr:hover) { background-color: #f1f5f9; }
:global(.dark) .about-rich-content :deep(table tbody tr:hover) { background-color: #1e293b; }
.about-rich-content :deep(table tbody td) { padding: 1.25rem 1.5rem; border-bottom: 1px solid #e2e8f0; color: #475569; }
:global(.dark) .about-rich-content :deep(table tbody td) { border-bottom-color: #334155; color: #cbd5e1; }
.about-rich-content :deep(table tbody td:first-child) { color: #0f172a; font-weight: 600; }
:global(.dark) .about-rich-content :deep(table tbody td:first-child) { color: #f8fafc; font-weight: 600; }
.about-rich-content :deep(figure.image) { margin: 4rem 0; border-radius: 2rem; overflow: hidden; border: 1px solid #e2e8f0; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.05); }
:global(.dark) .about-rich-content :deep(figure.image) { border-color: #1e293b; box-shadow: 0 20px 25px -5px rgba(0,0,0,0.3); }
.about-rich-content :deep(figure.image img) { width: 100%; height: auto; display: block; margin: 0; }
.about-rich-content :deep(figure.table) { display: flex; justify-content: center; margin: 3rem auto; width: 100%; overflow-x: auto; }
</style>
